export const fieldDisplay = {
    inject: ['translate'],
    props: {
        templateString: {type: String},
        fields: {type: Array},
        join: {type: String, default: ', '}
    },
    data: function () {
        return {
            fieldValues: {},
        }
    },
    mounted() {
        this.fields.forEach((field) => {
            Vue.set(this.fieldValues, field.field, field.value);
        });
    },
    methods: {
        getLabelFromValueset: function(field, valueset) {
            let item = valueset.find((valuesetElement) => {
                return valuesetElement.value == this.fieldValues[field];
            });

            return item == null ? '' : item.label;
        }
    },
    computed: {
        fieldsLabel: function() {
            let pieces = this.templateString.split(' ');
            let result = [];
            this.fields.forEach((field) => {
                let replacement = field.valueset === null
                    ? field.value
                    : this.getLabelFromValueset(field.field, field.valueset);
                if ((replacement != '') && (replacement != null)) {
                    result.push(replacement);
                }
            });

            // let result = this.templateString;
            // this.fields.forEach((field) => {
            //     let replacement = field.valueset === null
            //         ? field.value
            //         : this.getLabelFromValueset(field.field, field.valueset);
            //     result = result.replace(':'+field.field, replacement);
            // });
            return result.join(this.join);
        }
    },
    watch: {
        fields: function() {
            this.fields.forEach((field) => {
                Vue.set(this.fieldValues, field.field, field.value);
            });
        }
    }

}
